/* Declares the store's shopping actions to in-browser agents (WebMCP).
   Registers nothing without document.modelContext or when the merchant turned
   the feature off (no data-webmcp on <body>). Data comes from Shopify only. */
(function () {
  if (window.__namyWebMCPInit) return;
  window.__namyWebMCPInit = true;

  var MAX = 10;
  var body = document.body;
  var root = function () { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; };
  var absolute = function (url) { return window.location.origin + String(url || '').split('?')[0]; };
  var money = function (cents) { return Mg.formatMoney(cents); };
  var count = function (v) { var n = Number(v); return Number.isInteger(n) && n > 0 ? n : 0; };
  var ok = function (data) { return { content: [{ type: 'text', text: JSON.stringify(data) }] }; };
  var fail = function (msg) { return { content: [{ type: 'text', text: 'Error: ' + msg }], isError: true }; };
  var schema = function (props, required) { return { type: 'object', properties: props || {}, required: required || [] }; };

  async function getJSON(url) {
    var r = await fetch(url, { headers: { Accept: 'application/json' } });
    if (!r.ok) throw Object.assign(new Error('HTTP ' + r.status), { status: r.status });
    return r.json();
  }

  async function readCart() {
    var cart = await Mg.cart.get();
    if (!cart) throw new Error('The cart could not be read. Try again.');
    return cart;
  }

  function cartView(cart) {
    return {
      item_count: cart.item_count,
      total: money(cart.total_price),
      currency: cart.currency,
      items: (cart.items || []).map(function (i) {
        return { variant_id: i.variant_id, title: i.title, quantity: i.quantity, line_price: money(i.final_line_price), url: absolute(i.url) };
      })
    };
  }

  /* "linen", "/products/linen", "https://shop/fr/products/linen?variant=1" → "linen" */
  function handleFrom(value) {
    var text = String(value || '').trim();
    var m = text.match(/\/products\/([^/?#]+)/);
    var handle = m ? m[1] : text;
    return /^[a-z0-9][a-z0-9-]*$/i.test(handle) ? handle : '';
  }

  var tools = [
    {
      name: 'search-products',
      description: 'Search the store catalog by keywords and return matching products with title, URL, price and availability.',
      inputSchema: schema({
        query: { type: 'string', description: 'Words the shopper is looking for, as typed.' },
        limit: { type: 'integer', minimum: 1, maximum: MAX, description: 'Maximum number of products. Defaults to 5.' }
      }, ['query']),
      annotations: { readOnlyHint: true },
      execute: async function (input) {
        var query = String((input && input.query) || '').trim();
        if (!query) return fail('Give a non-empty "query", for example {"query": "blue shirt"}.');
        var data = await getJSON(root() + 'search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=' + MAX);
        /* Products carrying a tag the merchant hides from search stay hidden. */
        var hidden = (body.getAttribute('data-webmcp-hidden-tags') || '').toLowerCase().split(',').map(function (t) { return t.trim(); }).filter(Boolean);
        var products = ((data.resources && data.resources.results.products) || [])
          .filter(function (p) { return !(p.tags || []).some(function (t) { return hidden.indexOf(String(t).trim().toLowerCase()) !== -1; }); })
          .slice(0, Math.min(count(input.limit) || 5, MAX))
          .map(function (p) {
            /* suggest.json gives the price in currency units ("699.95"), not cents. */
            return { title: p.title, handle: p.handle, url: absolute(p.url), price: money(Math.round(parseFloat(p.price) * 100)), available: p.available !== false };
          });
        return ok(products.length ? { query: query, products: products } : { query: query, products: [], note: 'No product matches. Try fewer or broader words.' });
      }
    },
    {
      name: 'get-product',
      description: 'Get a product from its handle or URL: variants with id, title, price, availability and options.',
      inputSchema: schema({ product: { type: 'string', description: 'Product handle (e.g. "linen-shirt") or product URL.' } }, ['product']),
      annotations: { readOnlyHint: true },
      execute: async function (input) {
        var handle = handleFrom(input && input.product);
        if (!handle) return fail('Give "product" as a handle or a URL containing /products/<handle>. Use search-products to find one.');
        var p;
        try {
          p = await getJSON(root() + 'products/' + handle + '.js');
        } catch (e) {
          if (e.status === 404) return fail('No product has the handle "' + handle + '". Use search-products to find a valid handle.');
          throw e;
        }
        return ok({
          title: p.title, handle: p.handle, url: absolute(p.url), vendor: p.vendor, available: p.available,
          options: (p.options || []).map(function (o) { return o.name || o; }),
          variants: (p.variants || []).map(function (v) {
            return { id: v.id, title: v.title, price: money(v.price), available: v.available, options: v.options };
          })
        });
      }
    },
    {
      name: 'get-cart',
      description: 'Get the shopper\'s current cart: items, quantities, line prices and total.',
      inputSchema: schema(),
      annotations: { readOnlyHint: true },
      execute: async function () { return ok(cartView(await readCart())); }
    },
    {
      name: 'add-to-cart',
      description: 'Add a product variant to the cart. Get the variant id from get-product first.',
      inputSchema: schema({
        variant_id: { type: 'integer', description: 'Variant id returned by get-product.' },
        quantity: { type: 'integer', minimum: 1, description: 'How many to add. Defaults to 1.' }
      }, ['variant_id']),
      annotations: {},
      execute: async function (input) {
        var id = count(input && input.variant_id);
        if (!id) return fail('Give "variant_id" as a positive integer taken from get-product.');
        var qty = input.quantity === undefined ? 1 : count(input.quantity);
        if (!qty) return fail('Give "quantity" as a positive integer, or leave it out to add 1.');
        /* Same path as the theme's add buttons: the drawer section comes back with the add. */
        var drawer = document.querySelector('mg-cart-drawer');
        var section = drawer && drawer.closest('.shopify-section');
        var data;
        try {
          data = await Mg.cart.add([{ id: id, quantity: qty }], section ? [section.id.replace('shopify-section-', '')] : [], { source: 'webmcp' });
        } catch (e) {
          return fail('Shopify refused to add variant ' + id + ': ' + e.message + ' Check the variant id and availability with get-product.');
        }
        MgEvents.publish(MgEvents.Events.CART_ITEM_ADDED, { source: 'webmcp', sections: (data && data.sections) || null });
        return ok({ added: { variant_id: id, quantity: qty }, cart: cartView(await readCart()) });
      }
    },
    {
      name: 'start-checkout',
      description: 'Open the checkout page for the current cart. The shopper reviews and pays there; this tool charges nothing.',
      inputSchema: schema(),
      annotations: { consequentialHint: true },
      execute: async function () {
        var cart = await readCart();
        if (!cart.item_count) return fail('The cart is empty. Add items with add-to-cart first.');
        var url = root() + 'checkout';
        setTimeout(function () { window.location.assign(url); }, 0);
        return ok({ opening: absolute(url), item_count: cart.item_count, total: money(cart.total_price) });
      }
    }
  ];

  window.MgWebMCP = { tools: tools };

  var mc = document.modelContext;
  if (!mc || typeof mc.registerTool !== 'function' || !body || !body.hasAttribute('data-webmcp')) return;
  tools.forEach(function (tool) {
    Promise.resolve().then(function () { return mc.registerTool(tool); })
      .catch(function (e) { Mg.debug('WebMCP:' + tool.name, e); });
  });
})();
